<button mat-icon-button matSuffix color="primary" *appRole="['Personas.Ver']" [routerLink]="['/personas',idPersona]" [disabled]="isDisabled" #tooltip="matTooltip" matTooltip="Ver mas info.">
    <mat-icon>{{'info'}}</mat-icon>
</button>
